// uploads data to firebase and returns a new gymJobID for use later
// also puts this ID in the redux

import { useDispatch, useSelector } from 'react-redux';
import useJobToFirebase from '/app/hooks/gym/addJobbToFirebase';
import usePrepareJobData from '@/app//hooks/gym/usePrepareJobData';
import { setStateValue } from '@/app/redux/slices/configGymSlice';

const useCreateBasicGymData = () => {
  const dispatch = useDispatch();
  const { prepareJobData } = usePrepareJobData(); // Use the custom hook
  const basketID = useSelector((state) => state.basket.basketData.basketID);
  const email = useSelector((state) => state.basket.customerData.email);
  const fullName = useSelector((state) => state.basket.customerData.fullName);

  const addJobToFirebase = useJobToFirebase();

  const createBasicGymData = async () => {
    const jobData = prepareJobData(); // Prepare the job data
    console.log(jobData);
    try {
      const gymJobID = await addJobToFirebase(jobData);
      console.log('Basic gym job created with ID:', gymJobID);
      dispatch(setStateValue({ key: 'gymJobID', value: gymJobID }));
      //return gymJobID;
    } catch (error) {
      console.error('Failed to create basic gym job:', error.message);
      throw error;
    }
  };

  return createBasicGymData;
};

export default useCreateBasicGymData;
